import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const Home = () => {
    return (
        <div className="container mt-5">
            <div className="row">
                {/* Section 1: Left Column for Text and Button */}
                <div className="col-md-6 d-flex align-items-center">
                    <div className="content-wrapper px-5">
                        <div>
                            <h1 className="display-4 mb-4 fw-bold">Welcome to the Digis Customer Portal</h1>
                            <h5 className="mb-4">Effortlessly manage all your Digis services in one convenient place. Stay organized, stay in control.</h5>
                            <div className="text-center">
                                {/* Conditional rendering based on user authentication status */}
                                {localStorage.getItem('authToken') ? (
                                    <Link to="/dashboard" className="btn btn-lg mt-5 rounded-pill px-5 fw-bold" style={{ backgroundColor: '#f7af3a', color: 'black' }}>
                                        Go to Dashboard
                                    </Link>
                                ) : (
                                    <Link to="/login" className="btn btn-lg mt-5 rounded-pill px-5 fw-bold" style={{ backgroundColor: '#f7af3a', color: 'black' }}>
                                        Get Started
                                    </Link>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Section 1: Right Column for Image */}
                <div className="col-md-6 d-flex justify-content-center align-items-center">
                    <img src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1747766541/Frame_3_i0ckgq.png" className="img-fluid" alt="Web Talent" />
                </div>
            </div>

            {/* Section 2 */}
            <div className="row mt-5 pt-5">
                {/* Left Column for Image */}
                <div className="col-md-6 d-flex justify-content-center align-items-center">
                    <img src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1747595008/Pie_Chart_Example_drl33e.png" className="img-fluid" alt="Web Talent" />
                </div>

                {/* Right Column for Text and Button */}
                <div className="col-md-6 d-flex align-items-center">
                    <div className="content-wrapper px-5">
                        <div>
                            <h1 className="display-4 mb-4 fw-bold">Product Development Hub</h1>
                            <h5 className="mb-4">Get clear, real-time updates on your project’s progress. Know exactly where it stands every step of the way.</h5>
                        </div>
                    </div>
                </div>
            </div>

            {/* Section 4 */}
            <div className="row align-items-center mt-5 pt-5">
                {/* Left Column for Text */}
                <div className="col-md-6">
                    <div className="content-wrapper px-5">
                        <h1 className="display-4 mb-4 fw-bold">Talent Pipeline Manager</h1>
                        <h5 className="mb-4">Seamlessly track every candidate’s progress - from first contact to final onboarding, all in a single, organized view.</h5>
                    </div>
                </div>

                {/* Right Column for Image */}
                <div className="col-md-6 d-flex justify-content-center">
                    <img src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1747668688/pipeline_ob0cw9.png" className="img-fluid" alt="Web Talent" />
                </div>
            </div>

            {/* Footer Section */}
            <footer className="mt-auto d-flex flex-wrap justify-content-between align-items-center py-3 my-4">
                <Link to="/" className="footer">
                    <img 
                        src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1747766352/Digis_Logo_L_h5ga78.png"
                        alt="Logo" 
                        className="logo-image" 
                        style={{ width: '200px' }} 
                    />
                </Link>
                <ul className="nav col-md-4 justify-content-end">
                    <li className="nav-item px-2">
                        <Link 
                            to="https://digiscorp.com" 
                            className="nav-link px-2 text-dark" 
                        >
                            Digis Corp
                        </Link>
                    </li>
                    <li className="nav-item px-2">
                        <Link 
                            to="https://digiscorp.com/contacts/" 
                            className="nav-link px-2 text-dark" 
                        >
                            Contact
                        </Link>
                    </li>
                    <li className="nav-item px-2">
                        <a 
                            href="https://digiscorp.com/terms-of-use/" 
                            className="nav-link px-2 text-dark" 
                            target="_blank" 
                            rel="noopener noreferrer"
                        >
                            Terms
                        </a>
                    </li>
                    <li className="nav-item px-2">
                        <a 
                            href="https://digiscorp.com/privacy-policy/" 
                            className="nav-link px-2 text-dark" 
                            target="_blank" 
                            rel="noopener noreferrer"
                        >
                            Privacy
                        </a>
                    </li>
                </ul>
            </footer>
        </div>
    );
};

export default Home;